import { ArsTableRowHeader, defaultColumnWidth, defaultRowHeight } from "../interface";

/**
 * Create a blankRowHeaderCell
 *
 * @param blankT - The value to use for the label of the blank row header cell
 * @param columnHeaderHeights - The heights to use for the blank row header cell
 *        either as an array of heights or a the number of default values to be repeated
 */
export const blankRowHeaderCell = <T>(
  blankT: T,
  columnHeaderHeights: number[] | number,
): ArsTableRowHeader<T> => ({
  width: defaultColumnWidth,
  label: blankT,
  heights: Array.isArray(columnHeaderHeights)
    ? columnHeaderHeights
    : Array(columnHeaderHeights).fill(defaultRowHeight),
});
